import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarSolid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 20,
	viewBox: "0 0 22 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.88599 0.693359C10.0422 0.380859 10.2375 0.185547 10.55 0.0683594C10.8625 -0.00976562 11.136 -0.00976562 11.4485 0.0683594C11.761 0.185547 11.9954 0.380859 12.1516 0.693359L14.6907 5.84961L20.3938 6.66992C20.7063 6.74805 20.9797 6.9043 21.175 7.13867C21.3704 7.41211 21.4485 7.68555 21.4485 7.99805C21.4485 8.31055 21.3313 8.58398 21.0969 8.81836L16.9563 12.8418L17.9329 18.5449C17.9719 18.8574 17.8938 19.1699 17.7375 19.4434C17.5813 19.7168 17.3469 19.873 17.0344 19.9512C16.7219 20.0293 16.4094 19.9902 16.136 19.834L11.0188 17.1777L5.90161 19.834C5.58911 19.9902 5.31567 20.0293 5.00317 19.9512C4.69067 19.873 4.41724 19.7168 4.26099 19.4434C4.10474 19.1699 4.02661 18.8574 4.10474 18.5449L5.0813 12.8418L0.940674 8.81836C0.706299 8.58398 0.550049 8.31055 0.550049 7.99805C0.550049 7.68555 0.628174 7.41211 0.823486 7.13867C1.0188 6.9043 1.29224 6.74805 1.6438 6.66992L7.34692 5.84961L9.88599 0.693359Z",
		fill: "currentColor"
	})
});
export default SvgStarSolid;
